import React, { useEffect, useState } from "react";

import "./numberInput.css";
import NumberInputCipher from "./numberInputCipher";

interface NumberInputProps {
    length: number;
    onFinish: (v: number) => void;
}

export default function NumberInput(props: NumberInputProps) {

    return <div className="number-input" style={{
        "gap": "calc((100% - " +  props.length + "*var(--cipher-size))/" + props.length + ")"
    }}>
        {Array.from(
            { length: props.length },
            (_, i) => <NumberInputCipher onFinish={(v) => {
                props.onFinish(v);
            }}/>
        )}
    </div>
}